import { lazy } from 'react';

const StandardDeliveryReceiptPage = lazy(() =>
  import('./StandardDeliveryReceipt'),
);
const CorreiosDeliveryReceiptPage = lazy(() =>
  import('./CorreiosDeliveryReceipt'),
);
const PorterDeliveryHubPage = lazy(() => import('./PorterDeliveryHub'));
const FlowDeliveryPage = lazy(() => import('./FlowDelivery'));

export default [
  {
    name: 'Correios Package Delivery',
    path: '/package-delivery-correios/:uuid',
    exact: true,
    component: CorreiosDeliveryReceiptPage,
  },
  {
    name: 'Standard Package Delivery',
    path: '/package-delivery',
    exact: true,
    component: StandardDeliveryReceiptPage,
  },
  {
    name: 'Standard Package Delivery',
    path: '/package-delivery/:uuid',
    component: StandardDeliveryReceiptPage,
  },
  {
    name: 'Porter Delivery Default',
    path: '/deposit-package',
    exact: true,
    component: PorterDeliveryHubPage,
  },
  {
    name: 'Porter Delivery Hub',
    path: '/deposit-package/:uuid',
    exact: true,
    component: PorterDeliveryHubPage,
  },
  {
    name: 'Porter Delivery Flow',
    path: '/deposit-package/:uuid/flow',
    component: FlowDeliveryPage,
  },
];
